<script>

export default {
  name: 'inject-codeaha-scratch-js',
  render: function (createElement) {
    const that = this
    this.$loadScript(that.$g.URL.codeaha25dLodashMinJs)
      .then(() => {
        return that.$loadScript(that.$g.URL.codeaha25dAetherMinJs)
      })
      .then(() => {
        return that.$loadScript(that.$g.URL.codeaha25dEsperMinJs)
      })
      //
      .then(() => {
        return that.$loadScript(that.$g.URL.codeaha25dScratchBlocksBlocklyCompressedVertical)
      })
      .then(() => {
        return that.$loadScript(that.$g.URL.codeaha25dScratchBlocksMessages)
      })
      .then(() => {
        return that.$loadScript(that.$g.URL.codeaha25dScratchBlocksScratchMessages)
      })
      .then(() => {
        return that.$loadScript(that.$g.URL.codeaha25dScratchBlocksBlocksCompressed)
      })
      .then(() => {
        return that.$loadScript(that.$g.URL.codeaha25dScratchBlocksBlocksCompressedVertical)
      })
      .then(() => {
        return that.$loadScript(that.$g.URL.codeaha25dScratchBlocksPythonCompressed)
      })
      .then(() => {
        return that.$loadScript(that.$g.URL.codeaha25dScratchBlocksStorage)
      })
      .then(() => {
        return that.$loadScript(that.$g.URL.codeaha25dCodeahaManagerJs)
      })
      //
      .then(() => {
        document['ccConfig'] = {'showFPS': false, 'frameRate': 60, 'project_type': 'javascript', 'debugMode': 0, 'renderMode': 0, 'id': 'gameCanvas'}
        return that.$loadScript(that.$g.URL.codeaha25dGameMinJs + '&uuid=' + this.$g.uuid())
      })
      .then(() => {
        window['Cocos']['cc']['loader']['setResPath'](that.$g.URL.codeaha25dHtml5Dir)
        this.$emit('injectCodeahaJSFinish', true)
      })
      .catch((err) => {
        // Failed to fetch script
        console.log(err)
      })
    return createElement('div', [])
  }
}
</script>
